import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=2d9eaa1d&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=2d9eaa1d&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9eaa1d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d9eaa1d')) {
      api.createRecord('2d9eaa1d', component.options)
    } else {
      api.reload('2d9eaa1d', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=2d9eaa1d&scoped=true", function () {
      api.rerender('2d9eaa1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/tradeManagement/tradeInquire/detail.vue"
export default component.exports